import { Link, NavLink } from "react-router-dom";
import { Menu, X, Shield } from "lucide-react";
import { useState } from "react";

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home", end: true },
    { to: "/faq/residents", label: "Residents", testid: "nav-faq-residents-link" },
    { to: "/faq/leaseholders", label: "Leaseholders", testid: "nav-faq-leaseholders-link" },
    { to: "/news", label: "News" },
    { to: "/projects", label: "Projects" },
    { to: "/history", label: "History", testid: "nav-history-link" },
    { to: "/rta", label: "Your RTA", testid: "nav-rta-link" },
  ];

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 border-b border-stone-200 bg-white/85 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-home-link">
            <div className="h-9 w-9 rounded-lg bg-[#c85a32] text-white flex items-center justify-center font-serif text-lg font-bold">
              S
            </div>
            <div className="leading-tight">
              <div className="font-serif text-lg font-semibold text-stone-900">Salford Town Hall</div>
              <div className="text-xs text-stone-500">Residents & Leaseholders Portal</div>
            </div>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testid || `nav-${l.label.toLowerCase()}-link`}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2 text-sm font-medium transition ${
                    isActive
                      ? "bg-amber-50 text-amber-900"
                      : "text-stone-700 hover:bg-stone-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/admin/login"
              data-testid="nav-admin-link"
              className="ml-2 inline-flex items-center gap-1.5 rounded-lg bg-stone-900 px-3 py-2 text-sm font-medium text-white hover:bg-stone-800"
            >
              <Shield className="h-4 w-4" /> Administration
            </Link>
          </nav>

          <button
            className="md:hidden rounded-lg p-2 text-stone-700 hover:bg-stone-100"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
        {open && (
          <div className="border-t border-stone-200 bg-white md:hidden">
            <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-lg px-3 py-2 text-sm font-medium ${
                      isActive ? "bg-amber-50 text-amber-900" : "text-stone-700 hover:bg-stone-100"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/admin/login"
                onClick={() => setOpen(false)}
                className="rounded-lg bg-stone-900 px-3 py-2 text-sm font-medium text-white"
              >
                Administration
              </Link>
            </div>
          </div>
        )}
      </header>

      <main>{children}</main>

      <footer className="border-t border-stone-200 bg-stone-50 mt-12">
        <div className="mx-auto max-w-7xl px-4 py-8 text-sm text-stone-600 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
            <div>© {new Date().getFullYear()} Salford Town Hall · Residents & Leaseholders Portal</div>
            <div className="text-xs text-stone-500">Managed by appointed Managing Agent</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
